/***
 * 工具函数
 */
import Vue from 'vue'
import { legic } from './legic'
import { decoratorUrl } from './helper'
import { getValidValue as getLastValue, url, isEmptyData } from '@zz-yp/hunter-js-utils'

/**
 * 动态计算px对于设计稿
 * @param {*} designPx 设计稿的宽度
 */
export function toRealPx(designPx, filter = false) {
  const clientWidth = document.documentElement.getBoundingClientRect().width
  const ratio = clientWidth > 750 ? 2 : 1
  const realPx = (designPx / (750 * ratio)) * clientWidth
  return filter ? realPx : `${realPx}px`
}

/**
 * 跳转
 * @param {*} targetUrl 落地页链接
 * @param {*} type 用于lego上报的类型，后面可接‘页面-模块-功能’
 * @param {*} needToMiniapp 是否是跳转小程序
 */
export function skipNotice(targetUrl, legoParams, needToMiniapp, hunterLoginCheck = false) {
  if (legoParams instanceof Object) {
    const { page, actiontype, backup } = legoParams
    legic(page, actiontype, backup)
  }
  if (targetUrl) {
    targetUrl = decoratorUrl(targetUrl)
    Vue.prototype.$native.skipToUrl({ targetUrl, needToMiniapp, hunterLoginCheck })
  }
}

/**
 * 获取统跳域名
 * @param {*} t 端t值
 */
export function getDomainName(t) {
  const domainMap = {
    15: 'zhuanzhuan', // 转转安卓
    16: 'zhuanzhuan', // 转转ios
    17: 'zhuanzhuan', //  转转卖家版安卓
    18: 'zhuanzhaun', // 转转卖家版ios
    72: 'zzhunter', // 采货侠安卓
    73: 'zzhunter' // 采货侠ios
  }
  return domainMap[t]
}

/**
 * @description: 获取一个对象中有效的值（不为空串的值）
 * @return:
 */
export function getValidValue(obj) {
  return getLastValue(obj)
}
// 格式化属性数据
export function formatAttributeSelections(origin, filterParams) {
  origin.map((item) => {
    item.data &&
      // eslint-disable-next-line array-callback-return
      item.data.map((ele) => {
        // 默认为未选
        // eslint-disable-next-line no-prototype-builtins
        ele.checked = filterParams.hasOwnProperty(item.queryVal)
      })
    return item
  })
  return origin
}

// 格式化型号数据
export function formatModelsSelections(origin) {
  let allModelCount = 0
  origin.map((item, index) => {
    if (item.modelList && item.modelList.length) {
      allModelCount += item.modelList.length
    }
    if (index === 0) {
      item.isCheckAll = true
    }
    item.checked = false
    // 默认为未选
    item.modelList &&
      item.modelList.forEach((ele) => {
        ele.checked = false
      })
    return item
  })
  origin[0].allModelCount = allModelCount
  return origin
}

// 格式化等级选项
export function formatLevelSelections(origin, b2bGradeIds = '') {
  const levelArr = (b2bGradeIds && b2bGradeIds.split('|')) || []
  origin.gradeList.map((item) => {
    // 默认为未选
    item.checked = levelArr.includes(item.id) && !item.isCheckAll

    return item
  })
  origin.groupList.map((item, index) => {
    if (!levelArr.length) {
      if (index === 0) {
        item.isCheckAll = true
        item.checked = false
      } else {
        item.isCheckAll = false
        item.checked = false
      }
    } else {
      // 默认为未选
      item.checked = levelArr.includes(item.id) && !item.isCheckAll
    }

    return item
  })
  return origin
}

// 格式化快筛选项
export function formatQuickSelections(origin, labelIds = '', otherKey) {
  // 这里的labelIds来自链接拼接的值 所以使用,分割
  const labelArr = String(labelIds).split(',')
  const format = origin.map((item) => {
    if (otherKey) {
      item[otherKey] &&
        // eslint-disable-next-line array-callback-return
        item[otherKey].map((elem) => {
          // 默认为未选
          elem.checked = elem.queryVal && labelArr.includes(elem.queryVal) && !elem.isCheckAll

          // 默认二级筛选按钮为未选
          elem.secondQuickChecked = false

          // 默认已选数组为空
          elem.checkedArr = []
        })
    } else {
      // 默认为未选
      item.checked = labelArr.includes(item.queryVal) && !item.isCheckAll

      // 默认二级筛选按钮为未选
      item.secondQuickChecked = false

      // 默认已选数组为空
      item.checkedArr = []
    }

    // 有子项 递归格式化子项数据
    if (item.childV2) {
      item.childV2 = formatQuickSelections(item.childV2, labelIds, 'items')

      item.childV2.forEach((elem) => {
        if (elem.items) {
          elem.items.checkedArr = elem.items.filter((childItem) => childItem.checked)
          elem.items.checked || (elem.items.checked = elem.items.checkedArr.length > 0)
        }
      })
    }

    // 有子项 递归格式化子项数据
    if (item.child) {
      item.child = formatQuickSelections(item.child, labelIds)
      item.checkedArr = item.child.filter((childItem) => childItem.checked)

      item.checked || (item.checked = item.checkedArr.length > 0)
    }
    return item
  })

  return format
}

/* 默认跳转选择地址页  scene=xxxx&*/
export const defaultAddressUrl =
  'https://m.zhuanzhuan.com/platform/user_address/address-list?needHideHead=1'

/**
 * @param {params} 需要在链接上添加的参数
 * @description 使用call方法将this传给当前方法
 * @description 选择地址需要传入addressId，
 * @address https://doc.weixin.qq.com/doc/w3_AZsAegbOAG085htX9EbSK2gEui3o6?scode=AJ4AfQfgAAw5III0TTAZsAegbOAG0&version=4.1.3.6008&platform=win
 */
export function goAddressUrl(params, needClose = 0) {
  let targetUrl = defaultAddressUrl
  if (!isEmptyData(params)) {
    targetUrl = url.setParams(params, targetUrl)
  }
  this.$native.skipToUrl({ targetUrl, needClose, needOpenNewpage: true })
}

// 将整个selectableAddedService以serverGroupId作为值进行分类成2维数组
export function classifyByKey(items, keyName) {
  return items?.reduce((classifier, item) => {
    if (!classifier[item[keyName]]) {
      classifier[item[keyName]] = []
    }
    classifier[item[keyName]].push(item)
    return classifier
  }, {})
}

// 判断字符串是否是乱码
// eslint-disable-next-line no-irregular-whitespace
// /​**
//  * 判断字符串是否包含大量乱码（非中文、非字母、非数字、非标点符号）
//  * @param {string} str - 待检测的字符串
//  * @returns {boolean} - 如果乱码比例 > 40%，返回 true，否则返回 false
//  */
export function isMessyCode(str) {
  if (!str || str.trim() === '') {
    return false // 空字符串不算乱码
  }

  // 1. 移除空白字符（空格、制表符、换行符等）
  let cleanedStr = str.replace(/[\s\t\r\n]+/g, '')

  // 2. 移除标点符号（中文和英文标点）
  cleanedStr = cleanedStr.replace(/[^\u4e00-\u9fa5a-zA-Z0-9]/g, '')

  // 3. 如果字符串被完全过滤掉（全是乱码），直接返回 true
  if (cleanedStr === '') {
    return true
  }

  // 4. 计算乱码比例
  const totalChars = str.length // 原始字符串长度（包括乱码）
  const validChars = cleanedStr.length // 有效字符（中文、字母、数字）
  const messyRatio = 1 - validChars / totalChars // 乱码比例

  // 5. 如果乱码比例 > 40%，返回 true
  return messyRatio > 0.4
}

export const removeQuery = (queryList, defaultUrl = location.href) => {
  const currentQuery = url.getParams(defaultUrl)
  const urlPath = defaultUrl.split('?')[0]
  queryList.forEach((key) => {
    delete currentQuery[key]
  })
  return url.setParams(currentQuery, urlPath)
}
